const SDK_VERSION = '7.100.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
